import { useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../components/context';
import { authApi } from '../api';

function Logout({ user, frozen, setAlert }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { onLogout } = useAuth();

  useEffect(() => {
    const logout = async () => {
      if (user || frozen) {
        try {
          const message = await authApi.logout();
          if (!location.state || (location.state && !location.state.noMessage))
            setAlert({ message, variant: 'success' });
          onLogout();
          navigate({ pathname: '/login' });
        } catch (error) {
          setAlert({ message: error, variant: 'warning' });
        }
      } else {
        navigate({ pathname: '/' });
      }
    };
    logout();
  }, []);

  return null;
}

export default Logout;
